<template>
  <!-- 动态表单 内含输入框，下拉选择，远程搜索，范围输入 -->
  <div class="top_form">
    <el-form ref="injectForm" :model="formData" class="form" :inline="true" label-position="right" :rules="formRule">
      <el-form-item v-for="(item, index) in formList" :key="index" :label="item.label"  :prop="item.prop">
        <!-- 输入框 -->
        <el-input :title="formData[item.prop]" v-if="item.type == 'input'" v-model="formData[item.prop]"
          :placeholder="`请输入${item.label}`"><template #prepend v-if = "(item.prop === 'rContent' || item.prop === 'wContent' || item.prop === 'min' || item.prop === 'max') && dataType.dataType === 1"><span>0x</span></template></el-input>
        <!-- 下拉选择框 -->
        <el-select v-else-if="item.type == 'select'" v-model="formData[item.prop]"
        @visible-change="handleVisibleChange" @change="handleChange" value-key="value" :multiple="item.multiple" :filterable="item.filterable" :placeholder="`请选择${item.label}`" ref="mySelect" :disabled="type !== 'add' && item.prop === 'protocolType'">
          <el-option v-for="(option,index) in item.options" :key="index" :value="option.value"
            :label="option.label"></el-option>
        </el-select>
        <!-- 远程搜索 下拉选择框 -->
        <el-select v-else-if="item.type == 'remote'" filterable remote :remote-method="handleRemote" :loading="loading"
        value-key="value"
        v-model="formData[item.prop]" @change="handleRemoteChange" :multiple="item.multiple">
          <el-option v-for="(option,index) in item.options" :key="index" :value="option"
            :label="option.label"></el-option>
        </el-select>
        <!-- 范围值 输入框 -->
        <!-- <div v-else style="display: flex; flex-direction: row;">
          <el-input label="最小值" style="width: 130px;" v-model="formData[item.prop].min" placeholder="请输入最小值" />
          <div style="margin: 0 15px;">~</div>
          <el-input label="最大值" style="width: 130px;" v-model="formData[item.prop].max" placeholder="请输入最大值" />
        </div> -->
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'InjectForm',
  emits: ['visible-change', 'remote-change', 'remote', 'change'],
  props: {
    // 表单列表
    formList: {
      type: Array,
      default: () => []
    },
    // 表单数据
    formData: {
      type: Object,
      default: () => {}
    },
    // 表单校验规则
    formRule: {
      type: Object,
      default: () => {}
    },
    // 远程搜索加载状态
    loading: {
      type: Boolean,
      default: false
    },
    addressList: {
      type: Array,
      default: () => []
    },
    // 添加索引属性
    index: {
      type: Number,
      required: false
    },
    // add  edit  copy
    type: {
      type: String,
      required: 'add'
    }
  },
  data () {
    return {
      // selectItem: {
      //   dataType: 0
      // },
      dataType: 0
    }
  },
  methods: {
    // 下拉框显示隐藏时触发
    handleVisibleChange (visible) {
      if (visible) {
        this.$emit('visible-change', true)
      }
    },
    handleChange (val) {
      this.selectItem = val
      if (val.length !== 1) {
        // 写数据
        this.dataType = this.addressList.find(item => item.value === val)
      }
      this.$emit('change', this.selectItem, this.index)
    },
    // 远程搜索框 选中内容改变时触发
    handleRemoteChange (query) {
      this.$emit('remote-change', query)
    },
    // 远程搜索时触发
    handleRemote (query) {
      this.$emit('remote', query)
    },
    // 表单校验
    handleValidation () {
      return this.$refs.injectForm.validate()
    }
  }
}
</script>

<style>
.top_form{
  /* margin-bottom: 30px; */
}
</style>
